/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { event } from '@zcode-ui/web-zumper-integrations'
import { PROP_NAMES } from '@zcode/mixpanel'
import type { GetState } from '@zcode/state-type'
import type { Dispatch } from 'redux'

import { getCurrentLocation } from '../../../inspectors/index'
import { selectFilters } from '../../../modules/filters/selectors/index'
import { mixpanelViewSection } from '../../../modules/mixpanel/thunks/mixpanelViewSection'

import { getTrackingPAProps } from './getTrackingPAProps'

interface trackViewPASectionProps {
  traktorName: string
  mixpanelName: string
}

export const trackViewPASection =
  ({ traktorName, mixpanelName }: trackViewPASectionProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const user = getUser(state)
    const filters = selectFilters(state)
    const location = getCurrentLocation(state)
    const props = getTrackingPAProps(state, dispatch)

    // traktor event
    dispatch(
      event({
        name: traktorName,
        props,
        user,
        filters,
        location,
      })
    )

    // mixpanel event
    dispatch(
      mixpanelViewSection(mixpanelName, {
        [PROP_NAMES.LISTING_IDS]: props.visiblePropertyIds,
      })
    )
  }
